import { List } from 'immutable';
import { loadReduxFolders, loadReduxBreadcrumbs, loadReduxSharedUsers } from './loadActions';

const deselectAllAssets = (asset, append) => ({
  type: 'DESELECT_ASSETS',
  asset,
  append,
});

const selectAllAssets = () => ({
  type: 'SELECT_ASSETS',
});

const deselectAllFolders = (asset, append) => ({
  type: 'DESELECT_FOLDERS',
  asset,
  append,
});

const selectAllFolders = () => ({
  type: 'SELECT_FOLDERS',
});

export const selectAsset = asset => ({
  type: 'SELECT_ASSET',
  asset,
});

export const deselectAsset = asset => ({
  type: 'DESELECT_ASSET',
  asset,
});

export const selectFolder = folder => ({
  type: 'SELECT_FOLDER',
  folder,
});

export const deselectFolder = folder => ({
  type: 'DESELECT_FOLDER',
  folder,
});

export function setReduxAssetFolder(id) {
  return {
    type: 'SET_ASSET_FOLDER',
    id,
  };
}

export function setReduxFilterString(filterString) {
  return {
    type: 'SET_FILTER_STRING',
    filterString,
  };
}

export function loadReduxFolderAssets(assets) {
  return {
    type: 'LOAD_FOLDER_ASSETS',
    assets,
  };
}

export function fetchAssets(folderId) {
  return (dispatch) => {
    fetch(`/folders/${folderId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    })
      .then(response => response.json())
      .then((json) => {
        const {
          assets,
          folders,
          breadcrumbs,
          shared_users,
        } = json;

        dispatch(setReduxAssetFolder(folderId));
        dispatch(loadReduxFolderAssets(List(assets)));
        dispatch(loadReduxFolders(List(folders)));
        dispatch(loadReduxBreadcrumbs(List(breadcrumbs)));
        dispatch(loadReduxSharedUsers(List(shared_users)));
        dispatch(setReduxFilterString(''));
      })
      .catch((response) => {
        console.log(response);
      });
  };
}

export function setFilterString(filterString) {
  return (dispatch) => {
    dispatch(setReduxFilterString(filterString));
  };
}

export function deselectAssetsAndFolders() {
  return (dispatch) => {
    dispatch(deselectAllAssets());
    dispatch(deselectAllFolders());
  };
}

export function selectAssetsAndFolders() {
  return (dispatch) => {
    dispatch(selectAllAssets());
    dispatch(selectAllFolders());
  };
}



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/actions/folderAssetActions.js